module.exports = __webpack_public_path__ + "media/images/Quill-5a976507.png";